<template>
  <div class="home data-panel-home">
    <Header title="运行状况"></Header>
    <div class="wechat-revenue wechat-panel">
      <div class="wechat-tips">
        <div>1.故障设备包括：设备离线、网络资源不可用、计算任务不可调度、设备内存小、设备硬盘小、设备调度失败。</div>
        <div>2.页面运行状况更新频率为 2 小时。</div>
      </div>
      <div class="wechat-device-info">
        <el-table
          v-if="deviceInfos && deviceInfos.length"
          :data="deviceInfos"
          stripe
          style="width: 100%"
        >
          <el-table-column
            prop="email"
            label="账号"
            align='center'
          >
          </el-table-column>
          <el-table-column
            prop="compute_normal"
            label="正常运行"
            align='center'
          >
          </el-table-column>
          <el-table-column
            prop="error_num"
            label="故障设备"
            align='center'
          >

            <template slot-scope="scope">
              <div
                class="wecht-device-detail"
                @click="showDetail(scope.row)"
              >设备详情</div>
            </template>
          </el-table-column>
        </el-table>
      </div>

    </div>
    <div class="tips wechat-divice-tips">具体设备详情请登录博纳云官网查看</div>
    <!-- 展示设备运行状况 -->
    <el-dialog
      title="运行状况"
      :visible.sync="showDetailDialog"
      width="80%"
    >
      <div class="wechat-device-item">账号设备总数: {{total}}</div>
      <div class="wechat-device-item">离线设备: {{network_offline}}</div>
      <div class="wechat-device-item">网络资源不可用: {{network_bad}}</div>
      <div class="wechat-device-item">计算任务资源不可调度: {{compute_unsche}}</div>
      <div class="wechat-device-item">内存小于1G: {{compute_lowmem}}</div>
      <div class="wechat-device-item">硬盘小于100G: {{compute_lowhd}}</div>
      <div class="wechat-device-item">调度失败: {{compute_untask}}</div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button type="primary" @click="showDetailDialog = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState, mapActions, mapMutations } from "vuex";
import Header from "@/WechatComponents/Header.vue";
const WECHAT_HOST = "https://open.weixin.qq.com/connect/oauth2/authorize";
import { getCookie } from "@/utils/utils";
import { Message } from "element-ui";
import moment from "moment";

export default {
  name: "home",
  components: {
    Header
  },
  data() {
    return {
      email: "",
      password: "",
      total: "",
      network_offline: "",
      network_bad: "",
      compute_untask: "",
      compute_unsche: "",
      compute_lowmem: "",
      compute_lowhd: "",
      showDetailDialog: false
    };
  },
  computed: mapState({
    openid: state => state.wechat.openid,
    emails: state => state.wechat.emails,
    deviceInfos: state => state.wechat.deviceInfos
  }),
  created() {
    try {
      let that = this;
      let openid = getCookie("openid") || this.$route.query.openid;

      let redirect_url =
        this.$route.query.redirect_url ||
        "https%3a%2f%2fconsole.bonuscloud.work%2fwechat%2fdevice";
      let appid = this.$route.query.appid || "wx95ccc89810c1da7f";
      let code = this.$route.query.code;

      if (openid || code) {
        this.openId = openid;

        this.getWechatInfo({ openid, code, type: "device" });
      } else {
        window.location.href = `${WECHAT_HOST}?appid=${appid}&redirect_uri=${redirect_url}&response_type=code&scope=snsapi_base&state=123#wechat_redirect`;
      }
    } catch (error) {
      alert(error);
    }
  },
  methods: {
    ...mapActions(["getWechatInfo", "bindWechatEmail"]),
    showDetail(item) {
      let {
        total,
        network_offline,
        network_bad,
        compute_untask,
        compute_unsche,
        compute_lowmem,
        compute_lowhd
      } = item;

      this.total = total;
      this.network_offline = network_offline;
      this.network_bad = network_bad;
      this.compute_untask = compute_untask;
      this.compute_unsche = compute_unsche;
      this.compute_lowmem = compute_lowmem;
      this.compute_lowhd = compute_lowhd;
      this.showDetailDialog = true;
    },
    bindEmail() {
      let that = this;
      let { password, email, openid } = this;

      if (!password || !email) {
        return Message({
          message: "请填写用户名和邮箱",
          type: "error"
        });
      }

      this.bindWechatEmail({
        openid,
        email,
        password
      }).then(res => {
        if (res.code === 200) {
          Message({
            type: "success",
            message: res.message
          });

          that.getWechatInfo({ openid });
        } else {
          Message({
            type: "error",
            message: res.message || "绑定失败，请重试"
          });
        }
      });
    }
  }
};
</script>

<style scoped lang="stylus">
.data-panel-home.home {
  height: auto !important;
}

.wechat-home {
  background: #fff;
  text-align: center;
  padding: 20px;
}

.bind-email-wrap {
  padding: 30px 20px;
  background: #fff;
  text-align: center;
}

.wechat-bind-email {
  margin: 20px 0;
}

.wechat-bind-email {
  margin-top: 20px;
}

.wechat-panel {
  background: #fff;
}

.wechat-data {
  margin: 20px;
}

.wechat-tips {
  font-size: 14px;
  padding: 8px 16px;
  margin: 40px 20px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 4px;
  position: relative;
  overflow: hidden;
  opacity: 1;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-transition: opacity 0.2s;
  transition: opacity 0.2s;
  background-color: #f4f4f5;
  color: #909399;
  line-height: 22px;
  text-align: left;
}

.wechat-device-info {
  margin: 0px 20px;
}

.wechat-divice-tips.tips {
  margin: 60px auto;
  font-size: 12px;
  position: fixed;
  bottom: 20px;
  text-align: center;
  width: 100%;
}

.wecht-device-detail {
  color: #15bcad;
}

.wechat-device-item{
  margin: 10px

}
</style>

